import React from 'react';
import { TwainGameId } from 'betgames-contract-js';
import { ReactComponent as TKickIcon } from '../t-kick.svg';
import { ReactComponent as TBasketIcon } from '../t-basket.svg';

interface IProps {
    gameId: TwainGameId;
    className?: string;
}

export const GameIconList = {
    [TwainGameId.B_RING]: TBasketIcon,
    [TwainGameId.T_KICK]: TKickIcon,
    [TwainGameId.RNG_B_RING]: TBasketIcon,
    [TwainGameId.RNG_T_KICK]: TKickIcon,
};

export const GameIcon: React.FC<IProps> = (props) => {
    const Icon = GameIconList[props.gameId];

    return <Icon className={props.className} />;
};
